import React from "react";
import { Modal } from "@material-ui/core";
import { Box, Dialog, DialogActions, DialogTitle, TextField, Typography } from "@mui/material";
import './LogoutDialogueBox.css';

const LogoutDialogueBox = ({
  title = "Are you sure you want to logout?",
  open,
  close,
  cancel,
  logout,
  ...rest
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",

    boxShadow: 24,
    p: 4,
  };
  return (
    <>
      {/* <Modal
        open={open}
        onClose={close}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h6 style={{ fontWeight: "500", padding: "5px 0px 5px 0px" }}>
            {title}
          </h6>
          <div className="pr-sm-4 pl-sm-4 pt-1">
            <div className="row justify-content-end no-gutters  ">
              <div className="col-auto">
                <button
                  style={{ marginRight: "-12px" }}
                  className="btn btn-danger btn-sm"
                  type="button"
                  onClick={cancel}
                >
                  Cancel
                </button>
              </div>
              <div className="col-auto">
                <button
                  style={{ marginRight: "10px" }}
                  className="btn btn-success btn-sm "
                  type="button"
                  onClick={logout}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>

        </Box>
      </Modal> */}
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="logoutDialogStyle"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogActions>
          <div className="row">
            <div className="col">
              <button
                style={{ marginRight: "-12px" }}
                className="btn btn-danger btn-sm"
                type="button"
                onClick={cancel}
              >
                Cancel
              </button>
            </div>
            <div className="col">
              <button
                style={{ marginRight: "10px" }}
                className="btn btn-success btn-sm "
                type="button"
                onClick={logout}
              >
                Logout
              </button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LogoutDialogueBox;
